var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":_vm.logInWithFacebook}},[_c('img',{attrs:{"alt":"Facebook icon","width":"30px","height":"30px","src":require("../../../public/assets/img/facebook.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }